import  { useState, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import html2pdf from 'html2pdf.js';
import styles from './ReferralPopup.module.scss';
import logoImage  from '../../asset/memic_logo.png'
import { useSelector, useDispatch } from "react-redux";
import { addProviderClaim } from '../../redux/ducks/provider';


const ReferralPopup = ({ open, onClose, providerDetails }) => {
  const contentRef = useRef(null);
  const { addedClaim } = useSelector((state) => state.provider);
  const dispatch = useDispatch();

  const initialFormData = {
  claimNumber: '',
  employer: '',
  employee: '',
  dateOfInjury: '',
  dateOfBirth: '',
  insuredName: '',
  examinerPhone: '',
  pharmacyOfChoice: '',
  examinerName: '',
  bodyPart: '',
};

  const [formData, setFormData] = useState(initialFormData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const isFormValid = () => {
    const requiredFields = [
      'claimNumber',
    ];

    const isAllFieldsFilled = requiredFields.every(field => formData[field].trim() !== '');
    return isAllFieldsFilled;
  };

  const generatePDF = async () => {
    try {
      console.log('Starting PDF generation...');
      if (!contentRef.current) {
        console.error('Content ref is null');
        return;
      }

      // Create a styled wrapper for PDF content
      console.log('Creating PDF content...');
      const pdfContent = document.createElement('div');
      pdfContent.style.fontFamily = 'Arial, sans-serif';
      pdfContent.style.fontSize = '12px';
      pdfContent.style.lineHeight = '1.5';
      pdfContent.style.color = '#000000';
      pdfContent.boxSizing= 'border-box';


      // Add logo
      const today = new Date();
      const formattedDate = today.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });

      const logoSection = document.createElement('div');
      logoSection.style.marginBottom = '20px';
      logoSection.innerHTML = `
        <img src="${logoImage}" alt="MEMIC Logo" style="width: 50px; height: auto;" />
        <div style="font-size: 12px; font-weight:bold; color: #000000; margin-top: 10px;">
          ${formattedDate}
        </div>
      `;

      //Add a data section
      
      // Create header section with form data in single column
      console.log('Creating header section...');
      const headerSection = document.createElement('div');
      headerSection.style.marginBottom = '40px';
      headerSection.innerHTML = `
        <div style="margin-bottom: 20px;">
          <div>
            <span style="display: inline-block; width: 120px;">Claim Number:</span>
            <span style="font-weight: bold;">${formData.claimNumber}</span>
          </div>
          <div>
            <span style="display: inline-block; width: 120px;">Employee:</span>
            <span style="font-weight: bold;">${formData.employee}</span>
          </div>
          <div>
            <span style="display: inline-block; width: 120px;">Employer:</span>
            <span style="font-weight: bold;">${formData.employer}</span>
          </div>
          <div>
            <span style="display: inline-block; width: 120px;">Date of Injury:</span>
            <span style="font-weight: bold;">${formData.dateOfInjury}</span>
          </div>
          <div>
            <span style="display: inline-block; width: 120px;">Date of Birth:</span>
            <span style="font-weight: bold;">${formData.dateOfBirth}</span>
          </div>
        </div>
      `;

      // Create the letter content
      console.log('Creating letter content...');
      const letterContent = document.createElement('div');
      letterContent.innerHTML = `
        <p>Dear <span style="font-weight:bold;">${providerDetails.title}</span> ,</p>
        <p>
          This letter verifies that you have been given authorization to evaluate and treat the above referenced employee for injuries related to the
          workers' compensation claim ${formData.bodyPart}.
        </p>
        <p>
          <strong>
            Per FL rule 69L-7.740 c) effective July 1, 2023, we may disallow payment for dispensed medication if the medication is not authorized by 
            MEMIC prior to dispensing, pursuant to Section 440.13(3)(a), F.S. Please call the MEMIC claim handler at the number below for 
            preauthorization.
          </strong>
        </p>
        <p style="margin: 0; padding: 0;">To avoid delays in obtaining medications, please note:</p>
        <div style="margin: 0 0 0 5px;">
          <ul style="margin:0;list-style: disc;">
            <li style="font-weight: bolder; color: #000000; margin:0;">
              <p style="margin: 0;">The injured worker has chosen the following as their pharmacy of choice:
                <span style="display:block; margin: 0 0 0 10px;">${formData.pharmacyOfChoice}</span>
              </p>
              <ul style="margin:0;list-style: circle;">
                <li style="margin:0;>
                  <p style="margin:0;>All prescriptions should be given to the injured worker or electronically sent to their  pharmacy of choice.</p>
                </li>
              </ul>
            </li>
            <li style="margin:0;">
              Additional treatment referrals require additional authorization (diagnostic testing, physical therapy, DME etc.). Please be sure to reach out to your claim specialist regarding this.
            </li>
          </ul>
        </div>
        <p style="margin-top:10px;">
          Medical bills should be sent with the corresponding records to: CorVel, P.O. Box 6726, Portland, OR 97228 or faxed to 888-835-1724.
        </p>
        <p>
          The DWC-25, medical records, and requests for authorization of non medication treatment should be faxed with the claim number to
          207-791-3334.Should you have any questions or need more information, please feel free to contact me at 
            <span style="font-weight: bolder; color: #000000;">${formData.examinerPhone}</span>
        </p>
        <p style="margin:100px 0 0 0;"><em>Sincerely,</em></p>
      `;


      const link = document.createElement('link');
      link.href = 'https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap';
      link.rel = 'stylesheet';
      document.head.appendChild(link);

      // Create signature section
      const signatureSection = document.createElement('div');
      signatureSection.style.marginTop = '10px';

      const cursiveSignature = document.createElement('div');
      cursiveSignature.textContent = formData.examinerName;
      cursiveSignature.style.fontFamily = "'Great Vibes', cursive";
      cursiveSignature.style.fontSize = '35px';
      cursiveSignature.style.textTransform = 'Capitalize';
      cursiveSignature.style.marginBottom = '10px';
      signatureSection.appendChild(cursiveSignature);


      const examinerName = document.createElement('div');
      examinerName.textContent = formData.examinerName;
      examinerName.style.fontWeight = 'bold';
      examinerName.style.color = '#66B3FF';
      
      const title = document.createElement('div');
      title.textContent = 'Claim Handler';
      title.style.marginTop = '5px';
      
      signatureSection.appendChild(examinerName);
      signatureSection.appendChild(title);

      // Assemble the final PDF content
      console.log('Assembling final PDF content...');
      pdfContent.appendChild(logoSection);
      pdfContent.appendChild(headerSection);
      pdfContent.appendChild(letterContent);
      pdfContent.appendChild(signatureSection);

      // PDF options
      const options = {
        margin: [15, 15, 15, 15],
        filename: `referral_${formData.claimNumber}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { 
          scale: 1.5,
          useCORS: true,
          logging: true
        },
        jsPDF: { 
          unit: 'mm', 
          format: 'a4', 
          orientation: 'portrait'
        }
      };

      setFormData(initialFormData);

      // Generate PDF blob first
      const pdfBlob = await html2pdf().set(options).from(pdfContent).output('blob');
      
      // Create URL for the blob
      const pdfUrl = URL.createObjectURL(pdfBlob);
      
      // Open preview in new tab
      window.open(pdfUrl, '_blank');

      // Create a File object from the blob
      const pdfFile = new File([pdfBlob], `referral_${formData.claimNumber}.pdf`, { type: 'application/pdf' });

      // Handle PDF generation and sharing
      const handlePdfGeneration = async () => {
        if (navigator.share && navigator.canShare({ files: [pdfFile] })) {
          try {
            await navigator.share({
              files: [pdfFile],
              title: `Referral for Claim ${formData.claimNumber}`,
              text: `Referral document for claim number ${formData.claimNumber}`
            });
          } catch (error) {
            await html2pdf().set(options).from(pdfContent).save();
          }
        } else {
          await html2pdf().set(options).from(pdfContent).save();
        }

        // Clean up and close
        setTimeout(() => {
          URL.revokeObjectURL(pdfUrl);
          onClose();
        }, 1000);
      };

      // Execute with a small delay to ensure preview is loaded
      setTimeout(handlePdfGeneration, 1000);

    } catch (error) {
      alert('Error generating PDF: ' + error.message);
    }
  };

  const handleGenerate = async () => {

    if (!isFormValid()) {
      return;
    }

    await dispatch(addProviderClaim({
        claimNumber: formData.claimNumber,
        npi: providerDetails.npi,
    }));
    if (addedClaim) {
      await generatePDF();
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      className={styles.dialog}
    >
      <DialogTitle className={styles.dialogTitle}>
        Create Referral
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={styles.dialogContent}>
        <div ref={contentRef}>
          <div className={styles.formGrid}>
            <TextField
              label="Claim Number"
              name="claimNumber"
              value={formData.claimNumber}
              onChange={handleChange}
              size="small"
              required
            />
            <TextField
              label="Employer"
              name="employer"
              value={formData.employer}
              onChange={handleChange}
              size="small"
            />
            <TextField
              label="Employee"
              name="employee"
              value={formData.employee}
              onChange={handleChange}
              size="small"
            />
            <TextField
              label="Date of Injury"
              name="dateOfInjury"
              type="date"
              value={formData.dateOfInjury}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              size="small"
            />
            <TextField
              label="Date of Birth"
              name="dateOfBirth"
              type="date"
              value={formData.dateOfBirth}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              size="small"
            />
          </div>

          <div className={styles.bodyContent}>
            <p>Dear {providerDetails.title},</p>
            <p>
              This letter verifies that you have been given authorization to evaluate and treat the above referenced employee for injuries related to the
              workers' compensation claim 
              <TextField
                  className={styles.bodyPartInput}
                  name="bodyPart"
                  value={formData.bodyPart}
                  onChange={handleChange}
                  size="small"
                  minRows={1}
                  maxRows={1}
                />
            </p>
            <p>
              <strong>
                Per FL rule 69L-7.740 c) effective July 1, 2023, we may disallow payment for dispensed medication if the medication is not authorized by 
                MEMIC prior to dispensing, pursuant to Section 440.13(3)(a), F.S. Please call the MEMIC claim handler at the number below for 
                preauthorization.
              </strong>
            </p>
            <p>To avoid delays in obtaining medications, please note:</p>
            <div className={styles.pharmacyContainer}>
              <div className={styles.pharmacy}>
                <label>The injured worker has chosen the following as their pharmacy of choice:</label>
                <TextField
                  name="pharmacyOfChoice"
                  value={formData.pharmacyOfChoice}
                  onChange={handleChange}
                  size="small"
                  multiline
                  minRows={1}
                  maxRows={4}
                />
              </div>
              <div className={styles.prescription}>
                <label>All prescriptions should be given to the injured worker or electronically sent to their pharmacy of choice.</label>
              </div>
            </div>
            <p>
              Additional treatment referrals require additional authorization (diagnostic testing, physical therapy, DME etc.). Please be sure to reach out to your claim specialist regarding this.
            </p>
            <p>
              Medical bills should be sent with the corresponding records to: CorVel, P.O. Box 6726, Portland, OR 97228 or faxed to 888 835 1724.
            </p>
            <p>
              The DWC-25, medical records, and requests for authorization of non medication treatment should be faxed with the claim number to
              207-791-3334.
            </p>
            <div className={styles.examinerPhone}>
              <label>Should you have any questions or need more information, please feel free to contact me at</label>
              <TextField
                label="Examiner Phone Number"
                name="examinerPhone"
                value={formData.examinerPhone}
                onChange={handleChange}
                size="small"
              />
            </div>
            <Grid className={styles.signatureCanvas} item xs={12}>
              <p>Sincerely,</p>
              <TextField
                label="Examiner Name"
                name="examinerName"
                value={formData.examinerName}
                onChange={handleChange}
                size="small"
              />
              <span>Claim Handler</span>
            </Grid>
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <Button 
            variant="outlined" 
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button 
            variant="contained" 
            onClick={handleGenerate}
            disabled={!isFormValid()}
          >
            Generate
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ReferralPopup; 